<template>
  <div
    v-if="Array.isArray(helpText.value)"
    class="mt-3"
  >
    <help-text
      v-for="(text, i) in helpText.value"
      :key="i"
      :class="['max-content-width', {'mt-3': i > 0}]"
      :error="error"
    >
      <div v-html="text" />
    </help-text>
  </div>

  <help-text
    v-else
    class="max-content-width"
    :error="error"
  >
    <p
      v-if="helpText.title"
      v-html="helpText.title"
    />
    <component
      :is="helpText.collapsible ? 'show-more' : 'div'"
      :open-text="openText"
      :hide-text="hideText"
    >
      <div v-html="helpText.value || helpText" />
    </component>
  </help-text>
</template>

<script>
export default {
  name: 'help-text-controller',
  props: {
    helpText: {
      type: Object,
      required: true,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    openText () {
      return this.helpText.collapsible
        ? (this.helpText.openerText || 'Show More')
        : false;
    },
    hideText () {
      return this.helpText.collapsible
        ? (this.helpText.closerText || this.helpText.openerText || 'Hide')
        : false;
    },
  },
};
</script>
